import { useForm, usePage, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

export default function ForgotPassword() {
  const { routes } = usePage().props;
  const form = useForm({ email_address: "" });

  function submit(e) {
    e.preventDefault();
    form.post(routes.passwords);
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Forgot your password?</CardTitle>
          <CardDescription>
            Enter your email and we'll send reset instructions if an account exists.
          </CardDescription>
        </CardHeader>

        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                autoComplete="username"
                autoFocus
                placeholder="you@example.com"
                value={form.data.email_address}
                onChange={(e) => form.setData("email_address", e.target.value)}
              />
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              {form.processing ? "Sending…" : "Send reset instructions"}
            </Button>
          </form>
        </CardContent>

        <CardFooter className="justify-center text-sm text-muted-foreground">
          <Link href={routes.login} className="text-primary hover:underline font-medium">
            Back to sign in
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}
